function getByPath(obj, path) {
  if (!obj || !path) return undefined;
  const parts = path.split(".");
  let cur = obj;
  for (let i = 0; i < parts.length; i += 1) {
    const key = parts[i];
    if (cur == null || typeof cur !== "object") return undefined;
    cur = cur[key];
  }
  return cur;
}

export function validateProjectQualStepEditForm(current) {
  const errs = {};
  if (!current || typeof current !== "object") return errs;

  // Field label mapping
  const fieldLabels = {
    "info.projectId": "Project",
    "info.qualificationStepId": "Qualification Step",
    "info.funnel": "Funnel",
    "info.stepNumber": "Step Number",
    "info.numberOfAttempts": "Number of Attempts",
    "info.estimatedTimeMinutes": "Estimated Time (minutes)",
  };

  // Required fields
  const required = [
    "info.projectId",
    "info.qualificationStepId",
    "info.funnel",
    "info.stepNumber",
    "info.numberOfAttempts",
    // Note: estimatedTimeMinutes is NOT required - it's a calculated field
  ];
  required.forEach((path) => {
    const v = getByPath(current, path);
    // Check for undefined, null, empty string, or whitespace-only string
    // Also check for falsy values that might be used as "not selected"
    const isEmpty =
      v === undefined ||
      v === null ||
      v === "" ||
      (typeof v === "string" && v.trim() === "") ||
      (typeof v === "number" && isNaN(v));
    if (isEmpty) {
      errs[path] = `${fieldLabels[path]}: This field is required`;
    }
  });

  // Integer checks for numeric fields if provided
  const intChecks = [
    "info.stepNumber",
    "info.numberOfAttempts",
    "info.estimatedTimeMinutes",
  ];
  intChecks.forEach((path) => {
    const v = getByPath(current, path);
    if (v !== undefined && v !== null && String(v) !== "") {
      const n = Number(v);
      if (!Number.isInteger(n))
        errs[path] = `${fieldLabels[path]}: Must be an integer`;
    }
  });

  // Business rule: Number of Attempts must not exceed 1
  const attempts = getByPath(current, "info.numberOfAttempts");
  if (attempts !== undefined && attempts !== null && String(attempts) !== "") {
    const n = Number(attempts);
    if (Number.isFinite(n) && n > 1) {
      // errs["info.numberOfAttempts"] = `${fieldLabels["info.numberOfAttempts"]}: Cannot exceed 1`;
    }
  }

  return errs;
}
